import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ListWindow, PageService, TabComponent } from "@xo/client-common";
import { Type2LongStringTable } from "./type2LongString.table";

@Component({
  selector: "spec-app-type2-long-string-list-window",
  templateUrl: "./type2LongString.list.html",
  styleUrls: ["./type2LongString.list.scss"]
})
export class Type2LongStringListWindowComponent extends ListWindow {

  @ViewChild("table", { static: false }) table: Type2LongStringTable;

  clickHandler: Function;

  constructor(changeDetectorRef: ChangeDetectorRef, private tab: TabComponent, public pageService: PageService) {
    super(changeDetectorRef);
  }

  init(filters?) {
    this.clickHandler = this.pageService.createOpenObject(
      "SpecApp/Type2LongStringPage",
      this.tab.system,
      (object) => `Type2LongString at ID:${object ? object.id : null}`,
      () => ({})
    );
    super.init(filters, this.table);
  }

  reload() {
    console.log("Type2LongStringList reload");
    super.reload();
    this.table.refreshList();
  }
}
